const translation = {
  // Navigation
  nav_home: 'בית',
  nav_gallery: 'גלריה',
  nav_features: 'מאפיינים',
  nav_location: 'מיקום',
  nav_contact: 'צור קשר',

  // Hero Section
  hero_title: 'יוקרה עכשווית בלב צפון איטליה',
  hero_subtitle: 'שטח פנימי כולל: 505 מ״ר | שטח מסחרי: 667.31 מ״ר | שטח חיצוני: 1,190 מ״ר | דירוג אנרגטי A3 | טכנולוגיית בית חכם | בריכת מים מלוחים מחוממת',
  hero_cta: 'קבע צפייה',
  hero_learn_more: 'למד עוד',
  hero_property_info: 'שטח פנימי כולל: 505 מ״ר | שטח מסחרי: 667.31 מ״ר | שטח חיצוני: 1,190 מ״ר | דירוג אנרגטי A3 | טכנולוגיית בית חכם | בריכת מים מלוחים מחוממת',

  // Key Info
  key_info_title: 'סקירת הנכס',
  key_info_size: 'שטח מגורים',
  key_info_size_value: '350 מ״ר',
  key_info_bedrooms: 'חדרי שינה',
  key_info_bedrooms_value: '4',
  key_info_bathrooms: 'חדרי רחצה',
  key_info_bathrooms_value: '3',
  key_info_energy: 'דירוג אנרגטי',
  key_info_energy_value: 'A3',
  key_info_year: 'שנת בנייה',
  key_info_year_value: '2020',
  key_info_parking: 'חניה',
  key_info_parking_value: 'מוסך כפול',

  // Description
  desc_title: 'מצוינות אדריכלית פוגשת חיים מודרניים',
  desc_p1: 'בחוץ, הווילה כוללת בריכת מים מלוחים מחוממת עם תאורת LED. המערכת משלבת אפשרויות כרומותרפיה ופועלת באופן אוטונומי לאיזון מלח ורמות pH. הגינה המקיפה מנוהלת על ידי מערכת השקיה אוטומטית המופעלת על ידי מיכל איסוף מי גשם תת‑קרקעי בנפח 10,000 ליטר.',
  desc_p2: 'לווילה דירוג אנרגטי A3. האנרגיה מסופקת דרך שתי מערכות פוטו‑וולטאיות (20 קילוואט בסך הכל) עם קיבולת אחסון של 40 קילוואט, דוד עיבוי הפועל על בסיס האנרגיה המיוצרת על ידי המערכת הפוטו‑וולטאית, 10 פאנלים סולאריים תרמיים וחימום תת‑רצפתי מחולק ל‑3 אזורים.',
  desc_p3: 'החומרים והטכנולוגיות המשמשים בכל הנכס הם באיכות גבוהה ונבחרו לפי פונקציונליות ועמידות: אבן צרפתית באזורים פנימיים מרכזיים (למשל, מטבח, חדרי רחצה), עץ טיק ימי לחדרי השינה, נגרות מותאמת אישית, מערכת אודיו‑וידאו משולבת Bang & Olufsen, מכשירי Siemens, Bosch, Liebherr, KitchenAid ו‑Miele, בקרת אקלים רב‑אזורית Daikin וניהול מרכזי של בריכה והשקיה.',
  desc_p4: 'הווילה ממוקמת בארצ\'יזאטה, במרחק הליכה (כ‑5 דקות) מתחנת הרכבת עם קשרים ישירים לוארזה, מילאנו, נמל התעופה מלפנסה, קומו ושווייץ. ברכב, וארזה נמצאת כ‑15 דקות; לוגאנו (שווייץ) כ‑30 דקות; ומילאנו או נמל התעופה מלפנסה 45‑60 דקות. המיקום מציע גישה מהירה לשירותים חיוניים ולנתיבי תחבורה עיקריים, מה שהופך אותו למתאים לקונים הדורשים ניידות יעילה ונכס מתקדם טכנולוגית עם עלויות תפעול נמוכות.',

  // Amenities
  amenities_title: 'שירותים פרימיום',
  amenities_subtitle: 'תכונות פרימיום לאורח חיים יוצא דופן',
  amenities_smart_home: 'מערכת בית חכם',
  amenities_smart_home_desc: 'אוטומציה דומוטית מלאה לתאורה, אקלים ואבטחה',
  amenities_heating: 'חימום תת‑רצפתי',
  amenities_heating_desc: 'חימום קרינה מחולק לאזורים בכל הנכס',
  amenities_climate: 'בקרת אקלים Daikin',
  amenities_climate_desc: 'מערכת HVAC פרימיום לנוחות מיטבית',
  amenities_pool: 'בריכת מים מלוחים מחוממת',
  amenities_pool_desc: 'כרומותרפיה LED עם איזון אוטומטי של מלח ו‑pH',
  amenities_audio: 'מערכת Bang & Olufsen',
  amenities_audio_desc: 'אודיו‑וידאו משולב בכל הבית',
  amenities_security: 'מערכת אבטחה',
  amenities_security_desc: 'אזעקה מתקדמת ומעקב CCTV',
  amenities_wellness: 'סאונה ובריאות',
  amenities_wellness_desc: 'אזור ספא פרטי עם סאונה (בבנייה)',
  amenities_fitness: 'מרחב כושר',
  amenities_fitness_desc: 'אזור חדר כושר ייעודי עם ציוד מקצועי',
  amenities_wine: 'מרתף יין',
  amenities_wine_desc: 'אחסון מבוקר אקלים לאוסף שלך',
  amenities_irrigation: 'שקיה חכמה',
  amenities_irrigation_desc: 'מערכת השקיה אוטומטית לגינה עם איסוף מי גשם',
  amenities_ev: 'תחנת טעינה לרכב חשמלי',
  amenities_ev_desc: 'טעינת רכב חשמלי במוסך',
  amenities_solar: 'מערכת אנרגיה סולארית',
  amenities_solar_desc: 'פוטו‑וולטאי 20 קילוואט עם אחסון סוללה 40 קילוואט‑שעה',

  // Gallery
  gallery_title: 'גלריית הנכס',
  gallery_exterior: 'מראה חיצוני',
  gallery_pool: 'אזור הבריכת',
  gallery_interior: 'עיצוב פנים',
  gallery_kitchen: 'מטבח מודרני',
  gallery_bedroom: 'חדר שינה ראשי',
  gallery_bathroom: 'חדר רחצה יוקרתי',
  gallery_img_1: 'חוץ – אזור הבריכה',
  gallery_img_2: 'חזית קדמית עם מוסך',
  gallery_img_3: 'גינה ואזור ישיבה לצד הבריכה',
  gallery_img_4: 'חזית אחורית עם פטיו וגג סולארי',
  gallery_img_5: 'מרפסת חיצונית מכוסה',
  gallery_img_6: 'זווית צדדית חיצונית',
  gallery_img_7: 'מבט אווירי (חוץ)',
  gallery_img_8: 'סלון (קומה ראשונה)',
  gallery_img_9: 'סלון עם קמין (קומה ראשונה)',
  gallery_img_10: 'סלון (קומה ראשונה)',
  gallery_img_11: 'סלון (קומה ראשונה)',
  gallery_img_12: 'סלון עם יציאה למרפסת (קומה ראשונה)',
  gallery_img_13: 'סלון (קומה ראשונה)',
  gallery_img_14: 'סלון – מערכת Bang & Olufsen Beosound Shape (קומה ראשונה)',
  gallery_img_15: 'אולם כניסה ראשי (קומה ראשונה)',
  gallery_img_16: 'אולם כניסה ראשי (קומה ראשונה)',
  gallery_img_17: 'גרם מדרגות פתוח עם מעקה זכוכית (קומה ראשונה)',
  gallery_img_18: 'גרם מדרגות פתוח עם מעקה זכוכית (קומה ראשונה)',
  gallery_img_19: 'חדר רחצה (קומה ראשונה)',
  gallery_img_20: 'אזור אוכל (קומה ראשונה)',
  gallery_img_21: 'חדר אוכל (קומה ראשונה)',
  gallery_img_22: 'שולחן אוכל (קומה ראשונה)',
  gallery_img_23: 'מטבח (קומה ראשונה)',
  gallery_img_24: 'חדר שינה (קומה ראשונה)',
  gallery_img_25: 'חדר ארונות (קומה ראשונה)',
  gallery_img_26: 'חדר כושר (קומה ראשונה)',
  gallery_img_27: 'חדר רחצה (קומה ראשונה)',
  gallery_img_28: 'חדר רחצה (קומה ראשונה)',
  gallery_img_29: 'חדר רחצה (קומה ראשונה)',
  gallery_img_30: 'עליית גג (קומה שנייה)',
  gallery_img_31: 'חדר שינה (קומה שנייה)',
  gallery_img_32: 'חדר שינה (קומה שנייה)',
  gallery_img_33: 'חדר רחצה (קומה שנייה)',
  gallery_img_34: 'חדר שינה (קומה שנייה)',
  gallery_img_35: 'חדר רחצה (קומה שנייה)',
  gallery_img_36: 'חדר רחצה (קומה שנייה)',
  gallery_img_37: 'גרם מדרגות (קומת קרקע)',
  gallery_img_38: 'מטבח וקולנוע ביתי (קומת קרקע)',
  gallery_img_39: 'אזור אוכל (קומת קרקע)',
  gallery_img_40: 'סלון עם קמין (קומת קרקע)',
  gallery_img_41: 'סלון (קומת קרקע)',
  gallery_img_42: 'חדר רחצה (קומת קרקע)',
  gallery_img_43: 'מוסך (קומת קרקע)',
  gallery_img_44: 'מטען רכב חשמלי 22 קילוואט מספק טעינה מהירה, טוען סוללה של 100 קילוואט‑שעה במלואה תוך כ‑4‑5 שעות.',
  gallery_img_45: 'מוסך (קומת קרקע)',
  gallery_img_46: 'מבט לגינה (קומת קרקע)',
  gallery_img_47: 'תוכנית קומת קרקע',
  gallery_img_48: 'תוכנית קומה ראשונה',
  gallery_img_49: 'תוכנית קומה שנייה',
  gallery_img_50: 'תוכנית קומת קרקע',
  gallery_img_51: 'תוכנית קומה ראשונה',
  gallery_img_52: 'תוכנית קומה שנייה',

  // Materials & Finishes
  materials_title: 'חומרים וגימורים',
  materials_stone: 'אבן צרפתית',
  materials_stone_desc: 'אבן טבעית פרימיום במטבח ובחדרי רחצה',
  materials_teak: 'עץ טיק ימי',
  materials_teak_desc: 'ריצוף ורהיטים חיצוניים עמידים',
  materials_carpentry: 'נגרות מותאמת אישית',
  materials_carpentry_desc: 'עבודת עץ איטלקית בעבודת יד',
  materials_audio: 'Bang & Olufsen',
  materials_audio_desc: 'מערכת בידור אודיו‑וידאו משולבת',
  materials_climate: 'בקרת אקלים Daikin',
  materials_climate_desc: 'מערכת חימום וקירור רב‑אזורית',
  materials_appliances: 'מכשירי פרימיום',
  materials_appliances_desc: 'מותגים אירופאיים מובילים למטבח ולכביסה',

  // Material Details
  material_1_name: 'עץ טיק ימי',
  material_1_desc: 'ריצוף חדרי שינה ולופט',
  material_2_name: 'טרוורטין רומי',
  material_2_desc: 'חדר הרחצה של הסוויטה הראשית',
  material_3_name: 'אבן טבעית ממחצבה לומברדית',
  material_3_desc: 'ריצוף קומת הקרקע',
  material_4_name: 'אבקת יש עם שרף',
  material_4_desc: 'ריצוף סביב הבריכה. חומר מרוכב שתוכנן להפחתת התחממות יתר של משטחי חוץ בחשיפה לשמש ולהבטחת משטח מונע החלקה.',
  material_5_name: 'גרניט שחור',
  material_5_desc: 'משטח עבודה במטבח',
  material_6_name: 'אבן צרפתית',
  material_6_desc: 'ריצוף הקומה הראשונה',
  material_7_name: 'עץ לרץ\'',
  material_7_desc: 'ארונות מטבח',

  // Key Info Details
  keyinfo_location_title: 'מיקום',
  keyinfo_location_1: 'Via Binaghetto 3, Arcisate (VA), איטליה',
  keyinfo_location_2: '8 ק״מ מוארזה',
  keyinfo_location_3: '30 דקות ללוגאנו, שווייץ',
  keyinfo_location_4: '30 ק״מ לאגם מאג\'ורה',
  keyinfo_location_5: '50‑60 דקות למילאנו',
  keyinfo_location_6: '37 ק״מ לנמל התעופה מלפנסה',

  keyinfo_property_title: 'פרטי הנכס',
  keyinfo_property_1: 'שנה: 2007–2010',
  keyinfo_property_2: 'שטח פנימי כולל: 505 מ״ר',
  keyinfo_property_3: 'גינה: ~1,190 מ״ר',
  keyinfo_property_4: 'דירוג אנרגטי: A3',
  keyinfo_property_5: '3 קומות',
  keyinfo_property_6: 'עיצוב אדריכלי פרימיום',

  keyinfo_layout_title: 'פריסה וחדרים',
  keyinfo_layout_1: '4 חדרי שינה',
  keyinfo_layout_2: '5 חדרי רחצה',
  keyinfo_layout_3: 'אזור מגורים מרווח',
  keyinfo_layout_4: 'מטבח ראשי',
  keyinfo_layout_5: 'מטבח שני',
  keyinfo_layout_6: 'משרד ביתי',
  keyinfo_layout_7: 'אזור כושר/חדר כושר',
  keyinfo_layout_8: 'מרתף יין',
  keyinfo_layout_9: 'חדר כביסה',
  keyinfo_layout_10: 'חדר רב‑תכליתי גדול',

  keyinfo_pool_title: 'בריכה ושטח חיצוני',
  keyinfo_pool_1: 'בריכת מים מלוחים (מחוממת)',
  keyinfo_pool_2: 'מערכת כרומותרפיה LED',
  keyinfo_pool_3: 'אזורי ישיבה חיצוניים',
  keyinfo_pool_4: 'גינה מעוצבת',
  keyinfo_pool_5: 'מערכת השקיה אוטומטית',
  keyinfo_pool_6: 'מיכל איסוף מי גשם תת‑קרקעי 10,000 ליטר',

  keyinfo_parking_title: 'חניה',
  keyinfo_parking_1: 'מוסך פנימי: עד 4 מכוניות',
  keyinfo_parking_2: 'חניה חיצונית: 3 מקומות נוספים',
  keyinfo_parking_3: 'תחנת טעינה לרכב חשמלי',
  keyinfo_parking_4: 'אזורי אחסון מאורגנים',

  keyinfo_energy_title: 'מערכות אנרגיה',
  keyinfo_energy_1: 'פוטו‑וולטאי: 2 מערכות, 20 קילוואט בסך הכל',
  keyinfo_energy_2: 'אחסון סוללה: קיבולת 40 קילוואט',
  keyinfo_energy_3: 'סולארי תרמי: 10 פאנלים',
  keyinfo_energy_4: 'משאבת חום יעילה',
  keyinfo_energy_5: 'מערכת גז גיבוי',
  keyinfo_energy_6: 'חימום תת‑רצפתי מחולק לאזורים',
  keyinfo_energy_7: 'בקרת אקלים Daikin',

  keyinfo_materials_title: 'חומרים פרימיום',
  keyinfo_materials_1: 'אבן צרפתית (מטבח וחדרי רחצה)',
  keyinfo_materials_2: 'טיק ימי (מרפסת)',
  keyinfo_materials_3: 'אבן טבעית ממחצבה לומברדית',
  keyinfo_materials_4: 'אבקת יש עם שרף (סביב הבריכה)',
  keyinfo_materials_5: 'גרניט שחור (משטח עבודה במטבח)',
  keyinfo_materials_6: 'עץ לרץ\' (ארונות מטבח)',
  keyinfo_materials_7: 'טרוורטין רומי (חדר רחצה של הסוויטה הראשית)',

  keyinfo_tech_title: 'טכנולוגיה ואבטחה',
  keyinfo_tech_1: 'מערכת בית חכם מלאה',
  keyinfo_tech_2: 'מערכת אודיו‑וידאו Bang & Olufsen',
  keyinfo_tech_3: 'מערכת אזעקה מתקדמת',
  keyinfo_tech_4: 'מעקב וידאו CCTV',
  keyinfo_tech_5: 'בקרת תאורה אוטומטית',
  keyinfo_tech_6: 'ניהול אזורי אקלים',
  keyinfo_tech_7: 'ניטור ביצועי פוטו‑וולטאי ובקרה וניהול משאבת חום ודוד דרך אפליקציית Buderus',

  keyinfo_main_title: 'מידע על הנכס',
  keyinfo_main_subtitle: 'מפרט מלא ותכונות',

  // Security & Safety
  security_title: 'אבטחה ובטיחות',
  security_intro: 'נכס זה כולל סט מלא של מערכות אבטחה מודרניות שתוכננו להבטיח הגנה אמינה וניהול מרחוק קל.',
  security_features_heading: 'תכונות אבטחה עיקריות:',
  security_alarm: 'מערכת אזעקה עם שלט רחוק',
  security_alarm_desc: 'מערכת אזעקה מודרנית שניתן לשלוט בה מרחוק דרך סמארטפון, המאפשרת לך לנטר ולנהל את האבטחה מכל מקום.',
  security_cameras: 'מצלמות מעקב וידאו',
  security_cameras_desc: 'מצלמות ברזולוציה גבוהה המותקנות בנקודות מפתח סביב הנכס, המספקות ניטור והקלטה רציפים.',
  security_windows: 'חלונות אנטי‑פריצה',
  security_windows_desc: 'כל החלונות מצוידים בזכוכית מחוזקת ועמידה לשבירה להגנה מוגברת.',
  security_doors: 'דלתות כניסה מחוזקות',
  security_doors_desc: 'דלתות הכניסה הראשיות בנייה פנימית עם מבנים מתכתיים לשיפור העמידות והאבטחה הכוללת.',

  // Automation & Smart Controls
  automation_title: 'אוטומציה ובקרות חכמות',
  automation_intro: 'הווילה מצוידת במערכות אוטומטיות שתוכננו לפשט את השימוש היומיומי ולשפר את היעילות בכל הבית.',
  automation_exterior_title: 'תריסים חיצוניים:',
  automation_exterior_1: 'מופעלים דרך יחידת בקרה מרכזית.',
  automation_exterior_2: 'בנויים מחומרים עמידים למים ולשלג לעמידות לאורך זמן.',
  automation_exterior_3: 'נסוגים אוטומטית ברוח חזקה להגנה נוספת באמצעות שני גלאי רוח המותקנים על הגג.',
  automation_exterior_4: 'מעוצבים ללא צורך ב"קופסת קסטה" עליונה, המבטיחים גימור אדריכלי נקי.',
  automation_exterior_5: 'הדגמת וידאו כלולה.',
  automation_interior_title: 'תריסים פנימיים:',
  automation_interior_1: 'נשלטים דרך מסך מגע מרכזי בתוך הבית.',
  automation_interior_2: 'ניתן להעלות או להוריד חדרים בודדים, קומות שלמות או את כל הבית בכמה לחיצות.',
  automation_interior_3: 'פעולה חלקה ושקטה שתוכננה לשימוש תכוף.',
  automation_interior_4: 'הדגמת וידאו כלולה.',
  automation_video_internal: 'העלה וידאו: הדגמת בקרת תריסים פנימיים.',
  automation_video_internal_app: 'הדגמת אפליקציה',
  automation_video_external: 'העלה וידאו: הדגמת אוטומציה של ת里斯ים חיצוניים.',
  automation_video_screens: 'רשתות',

  // Operating Costs
  costs_title: 'עלויות תפעול ויעילות אנרגטית',
  costs_intro: 'וילה זוHasBeen.SaveChanges על עלויות התפעול תחת שליטה תוך שמירה על רמת נוחות גבוהה לאורך כל השנה. הודות למערכות אנרגיה מתקדמות וייצור באתר, ההוצאות הכוללות נשארות מוגבלות ביחס לגודל ולביצועים של הנכס.',
  costs_annual_title: 'עלויות תפעול שנתיות (משוערות):',
  costs_water: 'מים',
  costs_water_amount: '€635.20',
  costs_internet: 'אינטרנט וטלפון',
  costs_internet_amount: '€424.68',
  costs_electricity_consumed: 'חשמל שנצרך',
  costs_electricity_consumed_amount: '€2,038.17',
  costs_gas: 'גז',
  costs_gas_amount: '€2,855.00',
  costs_total_utilities: 'סך כל השירותים',
  costs_total_utilities_amount: '€5,952.00',
  costs_electricity_sold: 'חשמל שנמכר חזרה לרשת',
  costs_electricity_sold_amount: '– €2,750.00',
  costs_waste_tax: 'מס פסולת עירוני',
  costs_waste_tax_amount: '€485.75',
  costs_net_annual: 'עלות שנתית נטו משוערת',
  costs_net_annual_amount: '€3,687.00',
  costs_comfort_title: 'נוחות ובקרת אקלים:',
  costs_comfort_pool: 'ממאי עד ספטמבר, הבריכה החיצונית (כ‑88,000 ליטר) מחוממת ל‑28°C.',
  costs_comfort_home: 'כל הבית נשמר בטמפרטורה קבועה של 22°C לאורך כל השנה, גם בקיץ וגם בחורף, באמצעות משאבת חום Daikin לתקופת הקיץ ומשאבת חום Buderus לניהול החימום התת‑רצפתי.',

  // Stats
  stats_energy: 'עצמאות אנרגטית',
  stats_water: 'מי גשם שנאספו',
  stats_solar: 'אנרגיה סולארית שיוצרה',
  stats_efficiency: 'יעילות אנרגטית',

  // By the Numbers Section
  by_numbers_title: 'במספרים',
  by_numbers_subtitle: 'מפרטים מרשימים המגדירים מצוינות',
  by_numbers_solar_generated: 'אנרגיה סולארית שיוצרה',
  by_numbers_solar_value: '8.21 מגה‑וואט‑שעה/שנה',
  by_numbers_rainwater: 'מי גשם שנאספו',
  by_numbers_rainwater_value: '10,000 ליטר',
  by_numbers_living_space: 'שטח מגורים',
  by_numbers_living_value: '505 מ״ר',
  by_numbers_garden: 'שטח גינה',
  by_numbers_garden_value: '1,190 מ״ר',
  by_numbers_bedrooms: 'חדרי שינה',
  by_numbers_bedrooms_value: '4',
  by_numbers_bathrooms: 'חדרי רחצה',
  by_numbers_bathrooms_value: '5',
  by_numbers_garage: 'מקומות חניה במוסך',
  by_numbers_garage_value: '4',
  by_numbers_solar_capacity: 'הספק מערכות פוטו‑וולטאיות',
  by_numbers_solar_capacity_value: '20 קילוואט',
  by_numbers_battery_capacity: 'קיבולת אחסון אנרגיה',
  by_numbers_battery_capacity_value: '40 קילוואט‑שעה',
  by_numbers_year: 'שנה',

  // Premium Services Section
  premium_services_title: 'שירותים פרימיום',
  premium_services_subtitle: 'תכונות פרימיום לאורח חיים יוצא דופן',
  premium_service_1_title: 'מערכת בית חכם',
  premium_service_1_desc: 'אוטומציה מלאה לתאורה, אקלים ואבטחה',
  premium_service_2_title: 'חימום תת‑רצפתי',
  premium_service_2_desc: 'חימום קרינה מחולק לאזורים בכל הנכס',
  premium_service_3_title: 'בקרת אקלים Daikin',
  premium_service_3_desc: 'מערכת HVAC פרימיום לנוחות מיטבית',
  premium_service_4_title: 'בריכת מים מלוחים מחוממת',
  premium_service_4_desc: 'כרומותרפיה LED עם איזון אוטומטי של מלח ו‑pH',
  premium_service_5_title: 'מערכת אנרגיה סולארית',
  premium_service_5_desc: 'פוטו‑וולטאי 20 קילוואט עם אחסון סוללה 40 קילוואט‑שעה',
  premium_service_6_title: 'איסוף מי גשם',
  premium_service_6_desc: 'מערכת איסוף 10,000 ליטר להשקיה',
  premium_service_7_title: 'אודיו Bang & Olufsen',
  premium_service_7_desc: 'מערכת שמע פרימיום משולבת בכל הבית',
  premium_service_8_title: 'מערכת אבטחה',
  premium_service_8_desc: 'אזרקָה מתקדמת ומעקב וידאו CCTV',
  premium_service_9_title: 'סאונה ובריאות',
  premium_service_9_desc: 'אזור ספא פרטי עם סאונה (בהקמה)',
  premium_service_10_title: 'תחנת טעינה לרכב חשמלי',
  premium_service_10_desc: 'טעינת רכב חשמלי במוסך',

  // Location
  location_title: 'מיקום מעולה',
  location_subtitle: 'ארצ\'יזאטה - איזון מושלם בין טבע וקישוריות',
  location_description: 'ממוקמת באזור הכפרי הציורי של ארצ\'יזאטה, וילה זו מציעה את האיזון המושלם בין שלווה לנגישות. תהנה משלוות הטבע בעודך רק דקות ספורות מערים מרכזיות, שדות תעופה בינלאומיים ואגמים מדהימים.',

  // Location Carousel Captions
  location_carousel_caption_1: 'וארזה – קמפו דיי פיאורי (אתר מורשת UNESCO)',
  location_carousel_caption_2: 'וארזה – גנים ציבוריים',
  location_carousel_caption_3: 'וארזה – מרכז היסטורי',
  location_carousel_caption_4: 'אגם וארזה',
  location_carousel_caption_5: 'אגם וארזה',
  location_carousel_caption_6: 'מילאנו – כיכר הדואומו',
  location_carousel_caption_7: 'מילאנו – גלריה ויטוריו אמנואלה השני',
  location_carousel_caption_8: 'מילאנו – נוף העיר',
  location_carousel_caption_9: 'אגם קומו',
  location_carousel_caption_10: 'אגם קומו – בלאג\'יו',

  // Experience Varese Section
  varese_experience_title: 'חווה את וארזה והסביבה הקסומה שלה',
  varese_experience_intro: 'וארזה – המכונה לעתים קרובות "עיר הגן" של איטליה – מקבלת אותך בשילוב של שירותים מעשיים וחוויות תרבותיות עשירות. שוכנת בין אגמים וגבעות למרגלות האלפים, עיר אלגנטית זו מציעה הכל ממתקני בריאות מהשורה הראשונה ועד בידור, טבע, קניות ותענוגות קולינריים. הנה מדריך מקיף שיעזור לך להפיק את המירב מוארזה וסביבתה.',

  // Health Services
  health_services_title: 'שירותי בריאות וחירום',
  health_services_intro: 'אם תזדקק לסיוע רפואי, וארזה והערים הסמוכות מציעות אפשרויות בריאות מצוינות:',
  health_services_note: 'כל אחד מהמתקנים הללו נגיש בקלות מוארזה, מה שמבטיח שקט נפשי במהלך שהותך. (אנו ממליצים לרשום את הכתובות שלהם; מבקרים בינלאומיים יעריכו שחברי צוות רבים מדברים אנגלית.)',
  health_service_1_name: 'Ospedale di Circolo e Fondazione Macchi (וארזה)',
  health_service_1_address: 'Viale Luigi Borri 57, 21100 Varese',
  health_service_1_desc: 'בית החולים הגדול ביותר בוארזה, מוכר ברמה הלאומית בטיפול המתמחה שלו.',
  health_service_2_name: 'Clinica Sant\'Anna (לוגאנו)',
  health_service_2_address: 'Via Sant\'Anna 1, 6924 Sorengo (Lugano)',
  health_service_2_desc: 'מרפאה פרטית מפורסמת בשירותי יולדות ובריאות נשים שלה.',
  health_service_3_name: 'Clinica Luganese Moncucco (לוגאנו)',
  health_service_3_address: 'Via Moncucco 10, 6900 Lugano',
  health_service_3_desc: 'מרפאת טיפול חירום ללא מטרות רווח המשרתת את אזור לוגאנו.',
  health_service_4_name: 'Ospedale San Raffaele (מילאנו)',
  health_service_4_address: 'Via Olgettina 60, 20132 Milano',
  health_service_4_desc: 'בית חולים פרטי מפורסם למחקר והוראה (חלק מ‑Gruppo San Donato), ידוע בטיפול המתמחה החדשני שלו.',
  health_service_5_name: 'Casa di Cura La Madonnina (מילאנו)',
  health_service_5_address: 'Via Quadronno 29, 20122 Milano',
  health_service_5_desc: 'בית חולים פרטי בלעדי בלב מילאנו, מוכר בטיפול האיכותי והממוקד במטופל שלו.',

  // Leisure and Culture
  leisure_culture_title: 'פנאי ותרבות בוארזה',
  leisure_culture_intro: 'למרות האווירה השלווה שלה, וארזה מתהדרת בסצנה תרבותית תוססת.',
  leisure_cinema_title: 'קולנוע',
  leisure_cinema_desc: 'לערב בקולנוע, פנה ל‑Multisala Impero Varese, קומפלקס קולנוע מודרני במרכז העיר הידוע במגוון הסרטים הרחב שלו וחוויית הצפייה הנוחה.',
  leisure_theater_title: 'הופעות חיות',
  leisure_theater_desc: 'אם אתה מעדיף הופעות חיות, בדוק את הרשימות המקומיות להצגות ב‑Teatro Openjobmetis (התיאטרון הראשי של וארזה) המארח קונצרטים, הצגות ואירועי עונתיים.',
  leisure_theater_caption: 'Teatro Openjobmetis',
  leisure_courses_title: 'מעורבות קהילתית',
  leisure_courses_desc: 'מחפש להתחבר לקהילה? Varese Corsi מציעה קורסים וסדנאות מאז 1985 – משיעורי שפה ובישול ועד ספורט ואמנויות – מספקת דרך מהנה להתערבב עם המקומיים וללמוד מיומנות חדשה.',
  leisure_festivals_title: 'אירועים ופסטיבלים',
  leisure_festivals_desc: 'וארזה גם מתעוררת לחיים עם אירועים ופסטיבלים לאורך כל השנה. בעיקר, העיר מארחת פסטיבל מוזיקת גוספל שנתית בכל קיץ – מאז 1999 פסטיבל הגוספל של וארזה מפגיש מקהלות מאיטליה ומרחבי העולם להופעות מרוממות. בנוסף, פסטיבל Estense בגנים ההיסטוריים Estensi מציג אופרה בחוץ, מוזיקה ותיאטרון, מוסיף נופך של קסם.',
  leisure_festivals_note: 'תמיד לבדוק את לוח השנה התיירותי של וארזה לתערוכות אמנות, ירידי אוכל ופסטיבלים מקומיים אחרים שעשויים לחפוף לשהותך. העימותים חמים וידידותיים – לעיתים תמצא משפחות, סטודנטים ומבקרים מתערבבים באירועים אלה.',
  leisure_festivals_caption: 'פסטיבל הגוספל של וארזה',

  // Education and International Schools
  education_title: 'חינוך ובתי ספר בינלאומיים',
  education_intro: 'למשפחות המתכננות להישאר באזור לתקופה ארוכה יותר, וארזה והסביבה מציעות אפשרויות חינוך מצוינות, כולל בתי ספר בינלאומיים המשרתים קהילות אקספט ומשפחות רב‑לאומיות.',
  education_european_school_title: 'בית הספר האירופי של וארזה',
  education_european_school: 'בית הספר האירופי מציע חינוך רב‑שפתי עם חמש חוות שפה (איטלקית, אנגלית, צרפתית, גרמנית והולנדית), והקהל התלמידים שלו (כ‑1,300+ תלמידים) מייצג 35‑40 לאומיות, יוצר סביבת למידה גלובלית באמת.',
  education_european_school_desc: 'ממוקם בוארזה, בית הספר האירופי של וארזה הוא חלק מרשת בתי הספר האירופיים ומציע תוכנית לימודים מובנית המובילה לבגרות אירופית – תעודה המוכרת באוניברסיטאות ברחבי אירופה ומעבר לה. בית הספר מכסה את כל הרמות מגן ילדים ועד תיכון, ומדגיש רב‑תרבותיות, רב‑לשוניות ומצוינות אקדמית.',
  education_international_schools_title: 'בתי ספר בינלאומיים נוספים באזור',
  education_tasis_title: 'TASIS (האקדמיה האמריקאית השווייצרית בשווייץ) – לוגאנו',
  education_tasis_desc: 'במרחק של כ‑30 דקות נסיעה מוארזה, TASIS היא בית ספר פנימייה ויום אמריקאי יוקרתי המציע תוכנית לימודים מבוססת ארה"ב (עם אפשרויות AP ו‑IB) באנגלית. הקמפוס שלו מושך משפחות בינלאומיות ומציע סביבה אקדמית מעולה.',
  education_isa_title: 'ISC (International School of Como) – קומו/גראנדייט',
  education_isa_desc: 'במרחק של כ‑40 דקות מוארזה, ISC מציעה תוכנית לימודים בינלאומית (IB) לתלמידים בגילאי 2‑18. בית הספר מדגיש חינוך הוליסטי ומושך משפחות אקספט מאזור האגמים.',
  education_local_schools_title: 'בתי ספר מקומיים',
  education_local_schools_desc: 'אם אתה מעדיף שילוב מלא בתרבות האיטלקית, וארזה מציעה בתי ספר ציבוריים ופרטיים איטלקיים איכותיים. רבים מהם ידועים ברמה האקדמית הגבוהה שלהם, ומשפחות רבות בוחרות בהם כדי שילדיהם ילמדו איטלקית ויתנסו במערכת החינוך המקומית.',

  // Skiing in the Alps
  skiing_title: 'סקי באלפים',
  skiing_intro: 'יתרון עצום של החיים בוארזה הוא הקרבה לאלפים, הפותחת אפשרויות סקי אינספור בחורף. כמה מאתרי הסקי הטובים ביותר באירופה נמצאים במרחק של כמה שעות נסיעה (בין שעה ל‑6 שעות ברכב), מה שהופך טיולי סקי סוף‑שבוע או טיולי יום לאפשריים למדי.',
  skiing_mottarone_title: 'מוטארונה (פיימונטה, איטליה)',
  skiing_mottarone_desc: 'אזור הסקי הקרוב ביותר למחוז האגמים של וארזה, מוטארונה מציעה סקי אלפיני וקרוס קאנטרי עם נוף מדהים של שבעה אגמים מהפסגה שלה. זהו אתר קטן יותר וידידותי למשפחות (כשעה משם) אידיאלי למתחילים ליום כיף, עם 25 ק"מ של מסלולים ורמות הרים נעימות. באופן מדהים, אתה יכול לנסוע לפסגה בדקות ספורות ולהחליק על סקי תוך כדי התבוננות באגם מאג\'ורה, אגם וארזה ומעבר לכך.',
  skiing_mottarone_caption: 'אזור סקי מוטארונה',
  skiing_san_domenico_title: 'סן דומיניקו (פיימונטה, איטליה)',
  skiing_san_domenico_desc: 'אתר אלפיני ידידותי למשפחות כשעה וחצי‑שעתיים מוארזה, ידוע בשלג אמין ושילוב טוב של מסלולים. סן דומיניקו יושב מעל עמק אוסולה ומתהדר בכיסוי שלג איכותי מתחילת דצמבר ועד תחילת מאי. עם 40 ק"מ של מסלולים בקושי משתנה (בתוספת פארק סנובורד ובית ספר לסקי), זה מושלם לגולשים בכל הרמות.',
  skiing_san_domenico_caption: 'סן דומיניקו',
  skiing_macugnaga_title: 'מקוניאגה (פיימונטה, איטליה)',
  skiing_macugnaga_desc: 'כשעתיים מוארזה, מקוניאגה היא אתר סקי קסום בצל מונטה רוזה (ההר השני בגובהו באלפים). הכפר האלפיני האותנטי הזה מציע כ‑40 ק"מ של מסלולים, כולל כמה ריצות מאתגרות מחוץ למסלול. הנוף של קרחוני מונטה רוזה עוצר נשימה, והواء שלווה יותר מאשר באתרים גדולים יותר.',
  skiing_macugnaga_caption: 'מקוניאגה',
  skiing_alagna_title: 'אלאניה ואלספיה (פיימונטה, איטליה)',
  skiing_alagna_desc: 'כשעתיים וחצי מוארזה, אלאניה ואלספיה הן חלק מאזור הסקי Monterosa Ski, המציע למעלה מ‑180 ק"מ של מסלולים מחוברים. זהו יעד מפורסם לסקי פרירייד וסקי מחוץ למסלול, עם שטח אלפיני מרהיב ואתגרי. המערכת של מעליות גונדולה מחברת בין שלושה עמקים, ומאפשרת לך לחקור מגוון רחב של שטח.',
  skiing_alagna_caption: 'אלאניה ואלספיה',
  skiing_cervinia_title: 'צ\'רוויניה / ברויל‑צ\'רוויניה (ואלה ד\'אוסטה, איטליה)',
  skiing_cervinia_desc: 'כשעתיים וחצי מוארזה, צ\'רוויניה היא אחד מאתרי הסקי הגבוהים ביותר באירופה, עם סקי כל השנה על הקרחון. האתר מחובר לצרמט שבשווייץ, ומציע למעלה מ‑360 ק"מ של מסלולים משותפים. הנוף של מטרורן (צרווינו באיטלקית) מדהים, והשלג אמין מאוד. צ\'רוויניה ידידותית למשפחות ומציעה מגוון רחב של מסלולים לכל הרמות.',
  skiing_cervinia_caption: 'צ\'רוויניה',
  skiing_courmayeur_title: 'קורמאייר (ואלה ד\'אוסטה, איטליה)',
  skiing_courmayeur_desc: 'כשלוש שעות מוארזה, קורמאייר היא עיירת סקי אלגנטית למרגלות מון בלאן. עם כ‑100 ק"מ של מסלולים ונוף מרהיב, קורמאייר מציעה שילוב של סקי מאתגר, מסעדות הרים מצוינות ואווירת אפרה‑סקי תוססת. זהו יעד פופולרי למשפחות ולגולשים מנוסים כאחד.',
  skiing_courmayeur_caption: 'קורמאייר',
  skiing_livigno_title: 'ליוויניו (לומברדיה, איטליה)',
  skiing_livigno_desc: 'כשלוש שעות מוארזה, ליוויניו היא עיירת סקי ייחודית הממוקמת בעמק גבוה (1,816 מטר) ליד הגבול השווייצרי. בזכות מעמדה כאזור פטור ממכס, ליוויניו מציעה קניות פטורות ממס – בונוס נחמד לאחר יום על המדרונות. עם למעלה מ‑115 ק"מ של מסלולים, פארקי שלג ושלג אמין, זהו יעד מצוין למשפחות וגולשים צעירים.',
  skiing_livigno_caption: 'ליוויניו',
  skiing_bormio_title: 'בורמיו (לומברדיה, איטליה)',
  skiing_bormio_desc: 'כשלוש שעות מוארזה, בורמיו היא עיירת סקי היסטורית הידועה במסלולי המירוץ המאתגרים שלה (כולל מסלול הגעוול העולמי Stelvio) ובמעיינות התרמיים הטבעיים שלה. עם כ‑50 ק"מ של מסלולים ונוף מדהים של הפארק הלאומי סטלביו, בורמיו מציעה שילוב ייחודי של סקי ובריאות.',
  skiing_bormio_caption: 'בורמיו',
  skiing_st_moritz_title: 'סנט מוריץ (גריזונס, שווייץ)',
  skiing_st_moritz_desc: 'כשלוש שעות מוארזה, סנט מוריץ היא אחת מעיירות הסקי היוקרתיות ביותר בעולם. עם למעלה מ‑350 ק"מ של מסלולים באזור אנגדין, שמש בשפע (כ‑322 ימי שמש בשנה) ומתקנים ברמה עולמית, סנט מוריץ מציעה חוויית סקי יוקרתית. העיירה גם מארחת אירועים יוקרתיים כמו פולו על קרח ומירוצי סוסים על האגם הקפוא.',
  skiing_st_moritz_caption: 'סנט מוריץ',
  skiing_zermatt_title: 'צרמט (ואלה, שווייץ)',
  skiing_zermatt_desc: 'כארבע שעות מוארזה, צרמט היא אחת מיעדי הסקי האייקוניים ביותר בעולם, עם נוף מדהים של מטרורן. עם למעלה מ‑360 ק"מ של מסלולים (מחוברים לצ\'רוויניה באיטליה) וסקי כל השנה על הקרחון, צרמט מציעה חוויית סקי בלתי נשכחת. הכפר נטול מכוניות, מה שמוסיף לקסם האלפיני שלו.',
  skiing_zermatt_caption: 'צרמט',
  skiing_verbier_title: 'ורבייה (ואלה, שווייץ)',
  skiing_verbier_desc: 'כארבע שעות מוארזה, ורבייה היא אחת מאתרי הסקי המפורסמים ביותר בשווייץ, הידועה בסקי מחוץ למסלול המאתגר שלה ובחיי הלילה התוססים שלה. עם למעלה מ‑410 ק"מ של מסלולים באזור 4 Vallées, ורבייה מציעה שטח סקי עצום ומגוון. זהו יעד פופולרי לגולשים מנוסים ולאלה מחפשים אתגר.',
  skiing_verbier_caption: 'ורבייה',
  skiing_chamonix_title: 'שאמוני (אוברן‑רון‑אלפ, צרפת)',
  skiing_chamonix_desc: 'כחמש שעות מוארזה, שאמוני היא עיירת סקי אגדית למרגלות מון בלאן. עם למעלה מ‑150 ק"מ של מסלולים ואפשרויות סקי מחוץ למסלול אינספור, שאמוני היא גן עדן לגולשים מנוסים. העיירה גם מציעה את הרכבל Aiguille du Midi, המוביל אותך ל‑3,842 מטר לנוף מרהיב של האלפים.',
  skiing_chamonix_caption: 'שאמוני',

  // Nature and Outdoor Activities
  nature_title: 'טבע ופעילויות חוץ',
  nature_intro: 'מעבר לסקי, וארזה והסביבה מציעות מגוון עצום של פעילויות חוץ לאורך כל השנה.',
  nature_campo_title: 'ק密集 דיי פיאורי',
  nature_campo_desc: 'אחד מאתרי מורשת UNESCO הקרובים ביותר לוארזה, ק密集 דיי פיאורי (שדה הפרחים) הוא הר קדוש עם שמונה קפלות בארוק המובילות לקדש סנטה מריה דל מונטה בפסגה. הטיול למעלה (כשעה וחצי) מציע נופים פנורמיים של האגמים והאלפים, והאתר הוא יעד פופולרי לעלייה לרגל ולטיולים. אתה יכול גם לנסוע ברכבל Funicolare (רכבל היסטורי) לפסגה.',
  nature_campo_caption: 'ק密集 דיי פיאורי',
  nature_lakes_title: 'אגמים',
  nature_lakes_desc: 'אזור וארזה מוקף באגמים מדהימים – אגם מאג\'ורה, אגם קומו, אגם לוגאנו ואגם וארזה עצמו. כל אחד מהם מציע פעילויות כמו שיט, שיט בקיאק, שיט בסאפ, שחייה ודיג. בקיץ, חופי האגמים הם מקומות פופולריים לפיקניקים ולהרפיה.',
  nature_lakes_caption: 'אגם מאג\'ורה',
  nature_hiking_title: 'טיולים רגליים ורכיבה על אופניים',
  nature_hiking_desc: 'הגבעות והרים סביב וארזה מציעים מאות קילומטרים של שבילי טיולים ורכיבה על אופניים. מטיולים קלים סביב האגמים ועד טיולים מאתגרים באלפים, יש משהו לכל רמת כושר. שביל האופניים סביב אגם וארזה פופולרי במיוחד למשפחות.',
  nature_hiking_caption: 'טיולים באזור וארזה',
  nature_golf_title: 'גולף',
  nature_golf_desc: 'אזור וארזה מציע מספר מגרשי גולף מצוינים, כולל Golf Club Varese ו‑Golf Club Castelconturbia, שניהם ידועים במסלולים היפים והמאתגרים שלהם.',
  nature_golf_caption: 'Golf Club Varese',

  // Sports and Recreation
  sports_title: 'ספורט ופנאי: ממירוצים ועד פעילויות נופש',
  sports_intro: 'לחובבי ספורט, וארזה וסביבתה מציעות הרבה מעבר לאטרקציות טבעיות בלבד.',
  sports_monza_title: 'אוטודרומו נציונאלה די מונצה',
  sports_monza_desc: 'אוהדי ספורט מוטורי ישמחו לדעת שהמסלול האגדי אוטודרומו נציונאלה די מונצה – המכונה "מקדש המהירות" – נמצא במרחק של כשעה נסיעה בלבד מוורזה. מסלול היסטורי זה מארח מדי שנה את הגרנד פרי האיטלקי של פורמולה 1, לצד אירועי מירוצים מרגשים נוספים, והפך לאתר עלייה לרגל לחובבי רכב. משפחות יכולות לתכנן טיול יום כדי לצפות במירוצים ברמה עולמית באווירה החשמלית של היציעים במונצה. גם כאשר אין מירוץ גדול, המסלול מציע ימי מסלול וחוויות נהיגה, שבהם תוכלו (או בני נוער חובבי אדרנלין) לנהוג במכוניות ביצועים על המסלול המפורסם. למעשה, מונצה נחשב לאחד המסלולים המהירים בעולם – ובימי מסלול ניתן להגיע למהירויות של מעל 270 קמ״ש בישורות הארוכות (בסביבה בטוחה ומבוקרת). חוויות אלו מתאימות גם למשפחות המחפשות בילוי בלתי נשכח או רעיון למתנה מיוחדת. בין אם תבחרו לנהוג בעצמכם או רק לבקר בפאדוק ובמוזיקת פורמולה 1, ביקור במונצה הוא אפשרות פנאי ייחודית שמבדילה את וארזה מיעדים רבים אחרים. דמיינו סוף שבוע אחד של סקי באלפים, ובשבוע הבא את שאגת מנועי הפורמולה 1 – זהו חלק מאורח החיים באזור זה.',
  sports_monza_caption: 'אוטודרומו נציונאלה די מונצה',
  sports_culture_title: 'תרבות ספורט עשירה',
  sports_culture_desc: 'מעבר למירוצים, אזור וארזה מתאפיין בתרבות ספורט ענפה. בעיר מתקנים לטניס, שחייה וקהילת רכיבה פעילה (שביל האופניים סביב אגם וארזה פופולרי במיוחד). לקבוצת הכדורסל המקומית של וארזה היסטוריה מפוארת, וילדים יכולים להצטרף למגוון מועדוני ספורט. האגמים הסמוכים (מאג\'ורה, לוגאנו וקומו) מציעים מועדוני שיט ואף חתירה – אליפויות איטליה בחתירה התקיימו באגם וארזה, מה שמדגיש את התאמתו לספורט ימי. בסופי שבוע, משפחות רבות מנצלות את הנסיעה הקצרה לחופי אגם מאג\'ורה ולפארקי הרפתקאות, או מבקרות בפארק הספארי בפומביה (גן חיות ופארק שעוועים בנסיעה של כ־40 דקות) ליום כיף עם הילדים. בחורף, אם רוצים הפסקה מהסקי, ניתן למצוא משטחי החלקה על הקרח באוויר הפתוח או אולמות ספורט מקורים בעיר. לאורך כל השנה, סביבת וארזה מציעה מענה כמעט לכל תחביב משפחתי – מרכיבת אופני הרים ורכיבה על סוסים בקיץ, ועד ליקוט פטריות וצילום טבע בסתיו.',

  // Shopping and Dining
  shopping_title: 'קניות ואוכל',
  shopping_varese_title: 'קניות בווארזה',
  shopping_varese_desc: 'מרכז העיר של וארזה הוא גן עדן לחובבי קניות, עם שילוב של בוטיקים אופנתיים, חנויות אומנים מקומיים ושווקים פתוחים. טיילו לאורך רחוב קורזו מטAUTO להולכי רגל ובסמטאות הסמוכות כדי לגלות חנויות אופנה מסוגננות, בוטיקים לנעליים איטלקיות, חנויות ספרים וחנויות עתיקות. בנוסף, במרכז העיר נמצא Centro Commerciale Le Corti – קניון מודרני ונוח לביקור, במיוחד בימים גשומים.',
  shopping_buosi_title: 'Pasticceria Buosi',
  shopping_buosi_desc: 'כשהגיע הזמן להפסקה, בתי הקפה והקונדיטוריות של וארזה מוכנים לכבוש את לבכם. אחד המקומות הבולטים הוא Pasticceria Buosi – קונדיטוריה ושוקולטריה משפחתית אייקונית. Buosi ידועה באיכותה וביצירתיות שלה, עם סניפים בווארזה ובוונגונו הסמוכה, וזכתה בפרסים רבים (השף הצעיר אנדראה בואוזי זכה בפרס ChocoCake בשנת 2018 והוכתר כאלוף איטליה לקונדיטוריה לנוער בשנת 2019). פנקו את עצמכם בשוקולדים הארטיזנליים או במשקה הדגל "Buosino" – משקה עשיר של שוקולד וקפה – ותטעמו את התשוקה והמקצועיות שמלווים את המקום מאז 1958.',
  shopping_buosi_caption: 'Pasticceria Buosi',
  shopping_dining_title: 'חוויות קולינריות',
  shopping_dining_desc: 'בכל הקשור לאוכל, מבחר המסעדות והפיצריות של וארזה לא יאכזב. Ristorante Pizzeria Piedigrotta הוא מקום אהוב במיוחד בעיר, המגיש פיצה נאפוליטנית אותנטית ופסטות משביעות באווירה חמה וידידותית. המקומיים משבחים את האווירה התוססת והשירות הקשוב, שלרוב מלווה בניחוח פיצה הנאפת בטאבון עץ ובמוזיקה איטלקית רכה ברקע. זהו מקום מושלם להירגע בו לאחר יום של טיולים. אם אתם מחפשים חוויית גורמה, בווארזה ובסביבתה תמצאו מספר מסעדות יוקרה (חלקן אף בעלות כוכב מישלן) המתמקדות במטבח לומברדי "מהשדה לצלחת" – כמו ריזוטו, דגים טריים מהאגמים ופטריות פורצ\'יני עונתיות. אל תשכחו להתענג גם על תרבות הקפה האיטלקית. פתחו את הבוקר בקפוצ\'ינו וקרואסון בקונדיטוריה היסטורית בפיאצה מונטה גראפה, או תהנו מג\'לטו אחר הצהריים תוך צפייה בעוברים ושבים. שוק וארזה השבועי הוא גם יעד מומלץ, לשיטוט בין גבינות מקומיות, נקניקים, תוצרת טרייה, ואולי לרכישת בקבוק יין אזורי או שמן זית כמזכרת.',

  // Day Trips and Special Events
  daytrips_title: 'טיולים ואירועים מיוחדים בסביבה',
  daytrips_intro: 'אחד היתרונות הבולטים של וארזה הוא מיקומה האסטרטגי – המאפשר יציאה קלה לטיולי יום מעשירים לשווייץ או לערים נוספות בלומברדיה. הנה כמה מהיעדים והחוויות שאסור לפספס בסביבה, ושיוסיפו עניין וגיוון לשהות שלכם:',
  daytrips_milan_title: 'מילאנו – תרבות ואופנה',
  daytrips_milan_desc: 'במרחק של כשעה בלבד ברכבת או ברכב מווארזה, מילאנו מציעה עולם שלם של חוויות תרבותיות. חובבי אופרה יכולים ליהנות ממופע בתיאטרון האגדי לה סקאלה (Teatro alla Scala) – בית האופרה ההיסטורי של מילאנו, שנחנך בשנת 1778 ונחשב לאחד המפורסמים בעולם בזכות האקוסטיקה המושלמת והבכורות האגדיות של יצירות מאת רוסיני, ורדי ופוצ\'יני. גם אם אינכם מתכננים לצפות במופע, סיורים מודרכים באולם המפואר ובמוזיאון של לה סקאלה הם חוויה מרתקת בפני עצמה. מילאנו היא גם בירת האופנה של איטליה. פנקו את עצמכם במסע קניות בגלריה ויטוריו אמנואלה השני – ארקדה מרהיבה מהמאה ה-19 עם תקרת זכוכית, המאכלסת בוטיקים יוקרתיים ובתי קפה אלגנטיים – או טיילו ברחוב ויא מונטה נפולאונה שבמתחם Quadrilatero della Moda, הנחשב ל"אזור הקניות היוקרתי ביותר במילאנו", עם כל מותגי האופנה והעיצוב המובילים. מפרדה ועד ארמני – זהו גן עדן לצפייה בחלונות ראווה (וגם מקו�� מצוין לזהות את הטרנדים האיטלקיים העדכניים). לאחר מכן, תוכלו להירגע עם אפריטיבו ברובע בררה האופנתי או לבקר באחד מהysterious המוסדות המפורסמים של מילאנו, כגון פינקוטקה די בררה או לראות את "הסעודה האחרונה" של לאונרדו דה וינצ\'י.',
  daytrips_milan_caption: 'מילאנו – גלריה ויטוריו אמנואלה השני',
  daytrips_como_title: 'אגם קומו – ג\'אז מתחת לכוכבים',
  daytrips_como_desc: 'במרחק של כ־40 דקות נסיעה מווארזה, אגם קומו קורא לכם עם נופים עוצרי נשימה ועיירות אלגנטיות. מעבר לביקור בווילות המפורסמות (כמו הגנים הבוטניים של וילה קרלוטה והواء הקולנועית של וילה בלביאנלו), מומלץ לבדוק את לוח אירועי הקיץ. אזור אגם קומו מארח מדי שנה את Festival Lago di Como, המפיח חיים בערבי הקיץ עם קונצרטים פתוחים ברחבי האגם. אחד החלקים הפופולריים במיוחד הוא פסטיבל Lario Jazz & Blues, שבו אמנים איטלקיים ובינלאומיים ידועים מופיעים בקונצרטים חינמיים בכיכרות ציוריות לצד המים. דמיינו ערב יולי חמים, יושבים על שפת האגם תחת כיפת השמיים, מאזינים לצלילי ג\'אז חיים המתפזרים מעל המים – חוויה בלתי נשכחת שמושכת גם מקומיים וגם מבקרים. חובבי מוזיקה קלאסית ייהנו גם מסדרת Sinfolario, הכוללת קונצרטים תזמורתיים באתרים היסטוריים לאורך האגם. בשעות היום תוכלו לעלות ברכבל אל מונטה ברֶה או מונטה סן סלווטורה וליהנות מתצפיות מרהיבות על האגם והאלפים. ואל תשכחו לטעום שוקולד שווייצרי איכותי או פרוסת עוגת לוגאנו באחת מהewnיצריות המקומיות!',
  daytrips_como_caption: 'אגם קומו',
  daytrips_lugano_title: 'לוגאנו – קסם שווייצרי',
  daytrips_lugano_desc: 'במרחק של כ־30 דקות נסיעה מווארזה, לוגאנו היא עיר שווייצרית מקסימה על שפת אגם לוגאנו. העיר מציעה שילוב של תרבות איטלקית ויעילות שווייצרית, עם טיילת אגם יפהפייה, חנויות יוקרה ומסעדות מצוינות. אל תפספסו את פארק סן מיקלה (Parco Ciani) – גן ציבורי מדהים על שפת האגם, או את הטיול למונטה ברֶה לנוף פנורמי.',
  daytrips_lugano_caption: 'לוגאנו',
  daytrips_maggiore_title: 'אגם מאג\'ורה – איי בורומיאן',
  daytrips_maggiore_desc: 'במרחק של כ־30 דקות נסיעה מווארזה, אגם מאג\'ורה הוא אחד האגמים היפים ביותר באיטליה. אל תפספסו את איי בורומיאן – Isola Bella, Isola Madre ו‑Isola dei Pescatori – עם הגנים המדהימים והארמונות ההיסטוריים שלהם. העיירה סטרזה על שפת האגם היא נקודת מוצא מצוינת לסיורי סירה.',
  daytrips_maggiore_caption: 'אגם מאג\'ורה – איי בורומיאן',

  // Appliances & Technology
  appliances_title: 'מכשירים וטכנולוגיה',
  appliances_subtitle: 'מותגים אירופאיים מובילים ומערכות חכמות',
  appliances_intro: 'הווילה מצוידת במכשירים פרימיום ממותגים אירופאיים מובילים, המבטיחים ביצועים, עמידות ויעילות אנרגטית.',

  appliance_1_name: 'תנור Siemens iQ700',
  appliance_1_desc: 'תנור חשמלי מובנה עם פירוליזה עצמית, בקרת טמפרטורה מדויקת ומצבי בישול מרובים.',
  appliance_2_name: 'כיריים אינדוקציה Siemens iQ700',
  appliance_2_name_alt: 'כיריים אינדוקציה Siemens iQ700',
  appliance_2_desc: 'כיריים אינדוקציה 4 אזורים עם בקרת מגע, הגנת התחממות יתר ותכונת בטיחות לילדים.',
  appliance_3_name: 'מדיח כלים Siemens iQ300',
  appliance_3_desc: 'מדיח כלים שקט במיוחד עם 6 תוכניות, קיבולת 13 מערכות כלים ודירוג אנרגטי A++.',
  appliance_4_name: 'מקרר‑מקפיא Liebherr Side‑by‑Side',
  appliance_4_desc: 'מקרר‑מקפיא גדול עם טכנולוגיית NoFrost, בקרת אקלים מדויקת ומדפים מתכווננים.',
  appliance_5_name: 'מקרר יין Liebherr',
  appliance_5_desc: 'מקרר יין עם 3 אזורי טמפרטורה, קיבולת 200 בקבוקים ובקרת לחות.',
  appliance_6_name: 'מכונת קפה Siemens EQ.9',
  appliance_6_desc: 'מכונת קפה אוטומטית מובנית עם מטחנת קפה קרמית, מערכת חלב אוטומטית ומסך מגע.',
  appliance_7_name: 'מיקרוגל Siemens iQ700',
  appliance_7_desc: 'מיקרוגל מובנה עם גריל, 900W ו‑5 רמות הספק.',
  appliance_8_name: 'מגירת חימום Siemens',
  appliance_8_desc: 'מגירת חימום מובנית לחימום כלים או שמירה על חום מנות.',
  appliance_9_name: 'מכונת כביסה Miele W1',
  appliance_9_desc: 'מכונת כביסה עם קיבולת 9 ק"ג, TwinDos (מינון אוטומטי של חומר כביסה) ודירוג אנרגטי A+++.',
  appliance_10_name: 'מייבש כביסה Miele T1',
  appliance_10_desc: 'מייבש כביסה עם משאבת חום, קיבולת 9 ק"ג ודירוג אנרגטי A+++.',
  appliance_11_name: 'שואב אבק מרכזי',
  appliance_11_desc: 'מערכת שואב אבק מרכזית המותקנת בכל הבית, עם שקעי יניקה בכל קומה.',
  appliance_12_name: 'מערכת אודיו‑וידאו Bang & Olufsen',
  appliance_12_desc: 'מערכת בידור משולבת עם רמקולים בכל הבית, טלוויזיות ומערכת שליטה מרכזית.',
  appliance_13_name: 'טלוויזיה Bang & Olufsen BeoVision',
  appliance_13_desc: 'טלוויזיה פרימיום עם איכות תמונה מעולה, עיצוב אלגנטי ושילוב עם מערכת האודיו.',
  appliance_14_name: 'רמקולים Bang & Olufsen Beosound Shape',
  appliance_14_desc: 'רמקולים מודולריים מותקנים על הקיר, עם עיצוב ייחודי ואיכות שמע מעולה.',
  appliance_15_name: 'מערכת בקרת אקלים Daikin',
  appliance_15_desc: 'מערכת חימום וקירור רב‑אזורית עם בקרת טמפרטורה מדויקת בכל חדר.',
  appliance_16_name: 'משאבת חום Buderus',
  appliance_16_desc: 'משאבת חום יעילה לחימום תת‑רצפתי ומים חמים, עם בקרה דרך אפליקציה.',
  appliance_17_name: 'מערכת פוטו‑וולטאית',
  appliance_17_desc: 'שתי מערכות פוטו‑וולטאיות (20 קילוואט בסך הכל) עם אחסון סוללה 40 קילוואט‑שעה.',
  appliance_18_name: 'מערכת סולארית תרמית',
  appliance_18_desc: '10 פאנלים סולאריים תרמיים לחימום מים.',
  appliance_19_name: 'מערכת בית חכם',
  appliance_19_desc: 'מערכת אוטומציה מלאה לתאורה, תריסים, אקלים ואבטחה, עם בקרה דרך מסך מגע ואפליקציה.',
  appliance_20_name: 'מערכת אזעקה',
  appliance_20_desc: 'מערכת אזעקה מתקדמת עם חיישני תנועה, חיישני דלתות וחלונות ובקרה מרחוק.',
  appliance_21_name: 'מצלמות CCTV',
  appliance_21_desc: 'מצלמות מעקב ברזולוציה גבוהה עם הקלטה והצגה מרחוק.',
  appliance_22_name: 'מערכת בקרת בריכה',
  appliance_22_desc: 'מערכת אוטומטית לניהול טמפרטורה, מלח, pH וכרומותרפיה LED.',
  appliance_23_name: 'מערכת השקיה אוטומטית',
  appliance_23_desc: 'מערכת השקיה לגינה עם תכנות זמנים ושימוש במי גשם מהמיכל התת‑קרקעי.',
  appliance_24_name: 'תחנת טעינה לרכב חשמלי',
  appliance_24_desc: 'מטען רכב חשמלי 22 קילוואט במוסך, מספק טעינה מהירה.',
  appliance_25_name: 'מערכת גילוי עשן',
  appliance_25_desc: 'גלאי עשן בכל הקומות, מחוברים למערכת האזעקה.',
  appliance_26_name: 'מערכת גילוי דליפת גז',
  appliance_26_desc: 'גלאי גז במטבח ובחדר הדוד, מחוברים למערכת האזעקה.',
  appliance_27_name: 'מערכת גילוי הצפה',
  appliance_27_desc: 'חיישני מים בחדרי רחצה, מטבח וחדר כביסה.',
  appliance_28_name: 'מערכת אוורור מבוקרת (VMC)',
  appliance_28_desc: 'מערכת אוורור מכנית מבוקרת עם החלפת חום, המבטיחה איכות אוויר מעולה ויעילות אנרגטית.',

  // Contact Section
  contact_title: 'צור קשר',
  contact_subtitle: 'מעוניין ללמוד עוד? צור איתנו קשר',
  contact_name: 'שם מלא',
  contact_email: 'אימייל',
  contact_phone: 'טלפון',
  contact_message: 'הודעה',
  contact_send: 'שלח הודעה',
  contact_info: 'פרטי קשר',
  contact_address: 'כתובת',
  contact_address_value: 'Via Binaghetto 3, Arcisate (VA), איטליה',
  contact_success: 'תודה! נחזור אליך בקרוב.',
  contact_error: 'משהו השתבש. אנא נסה שוב.',

  // Form Validation
  form_required: 'שדה זה נדרש',
  form_email_invalid: 'כתובת אימייל לא תקינה',
  form_phone_invalid: 'מספר טלפון לא תקין',
  form_message_too_short: 'ההודעה קצרה מדי (מינימום 10 תווים)',

  // Footer
  footer_rights: 'כל הזכויות שמורות',
  footer_privacy: 'מדיניות פרטיות',
  footer_terms: 'תנאי שימוש',
  footer_description: 'וילת יוקרה עכשווית בארצ\'יזאטה, איטליה. שטח פנימי כולל 505 מ״ר, דירוג אנרגטי A3, טכנולוגיית בית חכם ובריכת מים מלוחים מחוממת.',
  footer_quick_links: 'קישורים מהירים',
  footer_contact_info: 'פרטי קשר',
};

export default translation;
